<template>
  <div class="newsContainer">
    <div class="home-top">
      <div class="head">
        <div class="companyName">
          <div>
            <a href="/"><img src="../../../public/images/campany.png" alt="" /></a>
          </div>
        </div>
        <div class="phone">
          <!-- <img src="../../assets/shouji.png" alt="">13241800875 -->
          <img class="menuCopy" @click="isSeeList()" src="../../assets/menu.png" alt="" />
        </div>
      </div>
      <!-- 移动端的menu菜单 -->
      <div class="copyMenu" v-if="isSeeMenuList">
        <a href="/"><div class="item">首页</div></a>
        <a href="aboutUs"><div class="item">关于我们</div></a>
        <a href="news"> <div class="item">公司资讯</div></a>
        <a href="businessnew"><div class="item">公司业务</div></a>
        <a href="joinUs"><div class="item" style="border-bottom: none">联系我们</div></a>
      </div>
      <div class="menu" v-if="!isSeeMenuList">
        <a href="/"><div class="item">首页</div></a>
        <div class="border">|</div>
        <a href="aboutUs"><div class="item">关于我们</div></a>
        <div class="border">|</div>
        <a href="news"> <div class="item">公司资讯</div></a>
        <div class="border">|</div>
        <el-popover placement="bottom" trigger="hover">
          <template #reference>
            <a href="businessnew"><div class="item">公司业务</div></a>
          </template>
          <a href="businessnew?type=1"><div class="one">培训服务</div></a>
          <a href="businessnew?type=2"><div class="one">资本服务</div></a>
          <a href="businessnew?type=3"><div class="one">产业服务</div></a>
          <a href="businessnew?type=4"><div class="one">咨询服务</div></a>
        </el-popover>
        <div class="border">|</div>
        <el-popover class="box-item" title="" content="暂未开放" placement="bottom">
          <template #reference>
            <a href=""><div class="item">数据库</div></a>
          </template>
        </el-popover>
        <div class="border">|</div>
        <a href="joinUs"><div class="item">联系我们</div></a>
      </div>
    </div>
    <!-- 主体 -->
    <div v-if="!isSeeMenuList">
      <main>
        <div class="top">
          <div class="title">
            <div class="imgBox"><img src="../../assets/wangxia.png" alt="" /></div>
            <div>
              <div class="chName">公司资讯</div>
              <div class="enName">/COMPANY NEWS</div>
            </div>
          </div>
          <!-- <div class="msg">企业成长的助力者，产业投资的连接者，资本市场服务新体系的践行者</div> -->
        </div>
        <!-- 新闻轮播 5个-->
        <div class="swiperBox">
          <el-carousel height="320px" >
             <el-carousel-item>
              <a href="https://mp.weixin.qq.com/s/322vJEf2v432HYCN-ZZJjg" target="_blank">
                <div class="itemBox">
                  <div class="left"><img src="../../assets/huodong4.jpg" alt="" /></div>
                  <div class="right">
                    <div class="title">
                    中资服Family | “国产GPU第二股”沐曦股份科创板挂牌上市
                    </div>
                    <div class="msg">
                    12月17日，中关村资本市场服务数字领导力DBA学员企业——沐曦集成电路（上海）股份有限公司（股票简称：沐曦股份，股票代码：688802.SH）正式在上海证券交易所科创板挂牌上市。
                    </div>
                    <div class="time">2025-12-17</div>
                  </div>
                </div>
              </a>
            </el-carousel-item>
             <el-carousel-item>
              <a href="https://mp.weixin.qq.com/s/aII08jfTP2Mh-1kN5fpTMA" target="_blank">
                <div class="itemBox">
                  <div class="left"><img src="../../assets/huodong3.jpg" alt="" /></div>
                  <div class="right">
                    <div class="title">
                    课程回顾 | 当WEB3遇见香港：WEB3领军人才计划首期班开课！
                    </div>
                    <div class="msg">
                    2025年12月12-14日，由中关村资本市场服务主办的“WEB3领军人才计划” 首期班课程在香港正式开启。
                    </div>
                    <div class="time">2025-12-16</div>
                  </div>
                </div>
              </a>
            </el-carousel-item>
            <el-carousel-item>
              <a href="https://mp.weixin.qq.com/s/E0SWeBwmZBYPuaXprLmPNg" target="_blank">
                <div class="itemBox">
                  <div class="left"><img src="../../assets/huodong222.jpg" alt="" /></div>
                  <div class="right">
                    <div class="title">
                    DBA实践课堂 | 产学融合新范式：数字领导力企业家学者DBA北京实践课堂成功举办
                    </div>
                    <div class="msg">
                    2025年11月6日，数字领导力企业家学者暨拉文大学DBA北京实践课堂成功举办。通过企业参访+深度研讨的形式，为同学们提供了沉浸式交流学习、思想碰撞的平台，共同探讨数字化时代背景下的企业创新发展新路径。
                    </div>
                    <div class="time">2025-11-12</div>
                  </div>
                </div>
              </a>
            </el-carousel-item>
            <el-carousel-item>
              <a href="https://mp.weixin.qq.com/s/NdaXV-Q449CudY9EyRKfFg" target="_blank">
                <div class="itemBox">
                  <div class="left"><img src="../../assets/huodong1.jpg" alt="" /></div>
                  <div class="right">
                    <div class="title">
                    活动报道 | 全球 RWA 前沿探索与商业实践，共探行业新机遇
                    </div>
                    <div class="msg">
                    2025年10月26日，由学说科技、中关村资本市场服务主办——“全球 RWA 前沿探索与商业实践” 活动在学说空间成功举办，此次活动汇聚各行业精英、聚焦全球RWA，展开深度研讨。
                    </div>
                    <div class="time">2025-10-29</div>
                  </div>
                </div>
              </a>
            </el-carousel-item>
            <el-carousel-item>
              <a href="https://mp.weixin.qq.com/s/lw8H5PCjM-I0qVINytzDlw" target="_blank">
                <div class="itemBox">
                  <div class="left"><img src="../../assets/yuenan2.jpg" alt="" /></div>
                  <div class="right">
                    <div class="title">
                     DBA海外课堂 | 走进越南产业核心，解锁中企出海新机遇
                    </div>
                    <div class="msg">
                     9 月 17 日-18 日，数字领导力DBA 海外课堂・越南站进入核心产业考察与深度交流阶段。同学们先后走进中国纺织龙头在越核心基地、越南代表性纺织企业、True North国际学校等产业标杆基地，为中企出海越南提供了宝贵的实战参考。
                    </div>
                    <div class="time">2025-09-23</div>
                  </div>
                </div>
              </a>
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- 新闻列表 8条-->
        <div class="newsList">
           <a href="https://mp.weixin.qq.com/s/322vJEf2v432HYCN-ZZJjg" target="_blank">
            <div class="newsOne">
              <div class="left">
                <div class="big">17</div>
                <div class="small">2025.12</div>
              </div>
              <div class="right">
                <div class="tit">
                  中资服Family | “国产GPU第二股”沐曦股份科创板挂牌上市

                </div>
                <div class="message">
                12月17日，中关村资本市场服务数字领导力DBA学员企业——沐曦集成电路（上海）股份有限公司（股票简称：沐曦股份，股票代码：688802.SH）正式在上海证券交易所科创板挂牌上市
                </div>
              </div>
            </div>
          </a>
          <a href="https://mp.weixin.qq.com/s/aII08jfTP2Mh-1kN5fpTMA" target="_blank">
            <div class="newsOne">
              <div class="left">
                <div class="big">16</div>
                <div class="small">2025.12</div>
              </div>
              <div class="right">
                <div class="tit">
                  课程回顾 | 当WEB3遇见香港：WEB3领军人才计划首期班开课！

                </div>
                <div class="message">
                2025年12月12-14日，由中关村资本市场服务主办的 “WEB3领军人才计划” 首期班课程在香港正式开启。
                </div>
              </div>
            </div>
          </a>
           <a href="https://mp.weixin.qq.com/s/E0SWeBwmZBYPuaXprLmPNg" target="_blank">
            <div class="newsOne">
              <div class="left">
                <div class="big">12</div>
                <div class="small">2025.11</div>
              </div>
              <div class="right">
                <div class="tit">
                  DBA实践课堂 | 产学融合新范式：数字领导力企业家学者DBA北京实践课堂成功举办
                </div>
                <div class="message">
                 2025年11月6日，数字领导力企业家学者暨拉文大学DBA北京实践课堂成功举办。通过企业参访+深度研讨的形式，为同学们提供了沉浸式交流学习、思想碰撞的平台，共同探讨数字化时代背景下的企业创新发展新路径。
                </div>
              </div>
            </div>
          </a>
           <a href="https://mp.weixin.qq.com/s/NdaXV-Q449CudY9EyRKfFg" target="_blank">
            <div class="newsOne">
              <div class="left">
                <div class="big">29</div>
                <div class="small">2025.10</div>
              </div>
              <div class="right">
                <div class="tit">
                  活动报道 | 全球 RWA 前沿探索与商业实践，共探行业新机遇
                </div>
                <div class="message">
                  2025年10月26日，由学说科技、中关村资本市场服务主办——“全球 RWA 前沿探索与商业实践” 活动在学说空间成功举办，此次活动汇聚各行业精英、聚焦全球RWA，展开深度研讨。
                </div>
              </div>
            </div>
          </a>
           <a href="https://mp.weixin.qq.com/s/lw8H5PCjM-I0qVINytzDlw" target="_blank">
            <div class="newsOne">
              <div class="left">
                <div class="big">23</div>
                <div class="small">2025.09</div>
              </div>
              <div class="right">
                <div class="tit">
                  DBA海外课堂 | 走进越南产业核心，解锁中企出海新机遇
                </div>
                <div class="message">
                  9 月 17 日-18 日，数字领导力DBA 海外课堂・越南站进入核心产业考察与深度交流阶段。同学们先后走进中国纺织龙头在越核心基地、越南代表性纺织企业、True North国际学校等产业标杆基地，为中企出海越南提供了宝贵的实战参考。
                </div>
              </div>
            </div>
          </a>
           <a href="https://mp.weixin.qq.com/s/GbaEM4Awg9HhCeqGjVGZig" target="_blank">
            <div class="newsOne">
              <div class="left">
                <div class="big">19</div>
                <div class="small">2025.09</div>
              </div>
              <div class="right">
                <div class="tit">
                  DBA海外课堂 | 初识越南，解码越南投资热土
                </div>
                <div class="message">
                  2025年9月14日-18日，数字领导力DBA海外课堂走进越南。在此期间，DBA同学们通过政策解读、企业参访、金融交流与文化体验，全方位探索越南投资机遇，加深了同学们对越南经济的了解，搭建起中越企业合作对接的桥梁。
                </div>
              </div>
            </div>
          </a>
          <a href="https://mp.weixin.qq.com/s/k7FCGHNkP-i6DeuHv1sx0g" target="_blank">
            <div class="newsOne">
              <div class="left">
                <div class="big">23</div>
                <div class="small">2025.07</div>
              </div>
              <div class="right">
                <div class="tit">
                  活动报道 | 数字领导力企业家学者DBA上海实践课堂成功举办
                </div>
                <div class="message">
                  2025年7月18-20日，数字领导力企业家学者DBA上海实践课堂成功举办。本次学习为期三天，通过哲学思辨、论文研讨、企业参访、校友交流等丰富形式，为师生搭建起一个跨界融合、思想碰撞的平台，共同探索数字时代下的领导力提升与产业发展新路径。
                </div>
              </div>
            </div>
          </a>
          <a href="https://mp.weixin.qq.com/s/hyhDM87qmR2OXsXIUybrKQ" target="_blank">
            <div class="newsOne">
              <div class="left">
                <div class="big">17</div>
                <div class="small">2025.07</div>
              </div>
              <div class="right">
                <div class="tit">
                  来访交流 | 新加坡南洋理工大学一行来访中关村资本市场服务
                </div>
                <div class="message">
                  7月16日，新加坡南洋理工大学商学院东盟与中国项目主任廖慧娟老师一行到访学说空间。中关村资本市场服务有限公司董事长、学说科技联合创始人梁昱博士等共同参会，双方进行了深入交流。
                </div>
              </div>
            </div>
          </a>
        
          <!-- <a href="https://mp.weixin.qq.com/s/KhG-dEM63MYma4xpjBnqEw" target="_blank">
                    <div class="newsOne">
                        <div class="left">
                            <div class="big">03</div>
                            <div class="small">2025.04</div>
                        </div>
                        <div class="right">
                            <div class="tit">2025中关村论坛年会｜共探新质生产力，共创全球科技未来</div>
                            <div class="message">2025中关村论坛年会于3月27日至31日在北京举行。中共中央政治局委员、国务院副总理张国清宣布论坛开幕，中共中央政治局委员、北京市委书记尹力，新加坡副总理王瑞杰等嘉宾出席开幕式。</div>
                        </div>
                    </div>
                </a>
                <a href="https://mp.weixin.qq.com/s/gUq51C2wBKI-CgRg4r5LAQ" target="_blank">
                    <div class="newsOne">
                        <div class="left">
                            <div class="big">17</div>
                            <div class="small">2025.03</div>
                        </div>
                        <div class="right">
                            <div class="tit">活动报道｜科创企业家领军人才培养计划：企业参访与闭门研讨会（第一期）圆满举行</div>
                            <div class="message">2025年3月15日，“新质科创·逐浪资本”科创企业家领军人才培养计划：企业参访与闭门研讨会（第一期）在汉王科技总部隆重举行。活动邀请中科金财与多家头部AI科创企业参与，汇聚产学研界领军者，以其独特的视角和实践深度，共同探讨人工智能技术的前沿趋势与产业应用，呈现了一场关于AI未来的思想盛宴。</div>
                        </div>
                    </div>
                </a>
                <a href="https://mp.weixin.qq.com/s/kiUp0Du-y4SYr5EveqPM2w" target="_blank">
                    <div class="newsOne">
                        <div class="left">
                            <div class="big">14</div>
                            <div class="small">2025.01</div>
                        </div>
                        <div class="right">
                            <div class="tit">2025企业家新年活动 | 中关村资本市场服务有限公司全新亮相</div>
                            <div class="message">2025年，中国正处于“十四五”与“十五五”规划交替期，中美博弈加剧，宏观形势复杂。企业家需在变局中谋破局，转挑战为机遇，助力高质量发展。</div>
                        </div>
                    </div>
                </a> -->
        </div>
      </main>
      <div class="home-bottom">
        <div class="box">
          <div class="left">
            <div>联系我们</div>
            <!-- <div>工作时间：09:00—18:00</div> -->
            <!-- <div>服务热线： 高老师  13241800875</div> -->
            <div>邮箱：contact@zgccms.com</div>
            <div>地址：北京海淀区中关村大街11号e世界B区一层</div>
          </div>
          <div class="linkBox">
            <el-select v-model="value" @change="getNewLink(value)" placeholder="相关链接">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="right">
            <div class="addWx">
              <img src="../../assets/gzh.jpg" alt="" />
              <div class="wxtext">公众号二维码</div>
            </div>
            <!-- <div class="addWx"><img src="../../assets/getmore.png" alt=""></div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
const isSeeMenuList = ref(false);

const isSeeList = () => {
  isSeeMenuList.value = true;
};

const value = ref("");
const options = ref([
  {
    value: "https://www.tsinghua.edu.cn/",
    label: "清华大学",
  },
  {
    value: "https://www.pbcsf.tsinghua.edu.cn/",
    label: "清华大学五道口",
  },
  {
    value: "https://www.zgcgroup.com.cn/",
    label: "中关村发展",
  },
  {
    value: "https://www.51xueshuo.com/#/home",
    label: "学说平台",
  },
]);

const getNewLink = (current) => {
  window.open(current);
};
</script>

<style lang="less">
.newsContainer {
  .home-top {
    height: 500px;
    .head {
      padding: 58px 150px;
      display: flex;
      justify-content: space-between;
      padding-bottom: 30px;
      .companyName {
        img {
          width: 300px;
        }
      }
      .phone {
        display: flex;
        width: 100px;
        font-size: 16px;
        color: #ffffff;
        align-items: center;
        img {
          width: 20px;
          height: 20px;
          margin-right: 15px;
        }
        .menuCopy {
          margin-left: 10px;
          display: none;
        }
      }
    }
    .menu {
      margin-top: -10px;
      display: flex;
      justify-content: center;
      align-items: center;
      a {
        .item {
          font-size: 18px;
          width: 236px;
          color: #ffffff;
        }
      }
      .border {
        color: #e1e1e1;
      }
    }
    .copyMenu {
      width: 100%;
      background-color: #fff;
      height: 100vh;
      margin-top: 196px;
      a {
        color: #333;
        letter-spacing: 2px;
        .item {
          height: 45px;
          line-height: 45px;
          border-bottom: 1px solid #cecece;
        }
      }
    }
  }

  .home-top::before {
    content: ""; /* 伪元素需要内容，即使它是空的 */
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: url(../../assets/newsbc.jpg) no-repeat center center,
      linear-gradient(180.06deg, rgb(46, 45, 45) 0.05%, rgb(30, 29, 29) 206.55%);
    background-size: cover;
    opacity: 1; /* 设置透明度 */
    z-index: -1; /* 确保伪元素在内容之下 */
    height: 500px;
  }
  main {
    background: #e1e1e1;
    .top {
      padding-top: 50px;
      padding-bottom: 52px;
      .title {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #0070b7;
        .imgBox {
          width: 52px;
          height: 52px;
          margin-right: 14px;
          img {
            width: 52px;
            height: 52px;
          }
        }

        .chName {
          font-size: 30px;
          font-weight: 600;
        }
        .enName {
          font-size: 10px;
          margin-top: 2px;
          text-align: left;
          // font-weight: 600;
        }
      }
      // .msg{
      //     margin-top: 18px;
      //     color: #333333;
      //     font-size: 18px;
      //     font-weight: 600;
      // }
    }
    .swiperBox {
      width: 68%;
      margin: 0 auto;
      height: 340px;
      .itemBox {
        display: flex;
        justify-content: center;
        padding-left: 60px;
        padding-right: 60px;
        margin-bottom: 30px;
        position: relative;
        .left {
          width: 432px;
          height: 300px;
          margin-right: 36px;
          img {
            width: 432px;
            height: 300px;
          }
        }
        .right {
          max-width: 836px;
          text-align: left;
          .title {
            max-width: 556px;
            color: #333333;
            font-size: 16px;
            margin-bottom: 34px;
            white-space: nowrap;
          }
          .msg {
            color: #999999;
            font-size: 14px;
            margin-bottom: 70px;
          }
          .time {
            position: absolute;
            bottom: 27px;
            color: #999;
            font-size: 12px;
          }
        }
      }
    }
    .newsList {
      width: 68%;
      margin: 0 auto;
      .newsOne {
        display: flex;
        justify-content: center;
        padding-bottom: 50px;
        .left {
          text-align: center;
          width: 120px;
          padding-right: 32px;
          border-right: 2px solid #ccc;
          .big {
            font-size: 36px;
            line-height: 42px;
            color: #333;
            font-family: MicrosoftYaHei;
          }
          .small {
            font-size: 20px;
            color: #999;
            font-family: MicrosoftYaHei;
          }
        }
        .right {
          margin-left: 44px;
          text-align: left;
          .tit {
            font-size: 16px;
            color: #333;
            margin-bottom: 20px;
          }
          .message {
            font-size: 12px;
            color: #999;
            width: 896px;
            overflow: hidden;
          }
        }
      }
      .newsOne:hover .big {
        color: #0070b7;
      }
      .newsOne:hover .tit {
        color: #0070b7;
      }
    }
  }
  .home-bottom {
    height: 330px;
    color: #fff;
    .box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 70px;
      width: 68%;
      margin: 0 auto;
      .left {
        width: 300px;
        text-align: left;
        line-height: 40px;
        font-size: 18px;
        white-space: nowrap;
      }
      .right {
        display: flex;
        // visibility:hidden;
        .addWx {
          // margin-right: 175px;
          img {
            width: 100px;
            height: 100px;
          }
          .wxtext {
            // margin-top: 14px;
            font-size: 14px;
          }
        }
      }
      .linkBox {
        width: 230px;
      }
    }
  }
  .home-bottom::after {
    box-shadow: 0 0 0px 330px rgba(0, 0, 0, 0.8);
    z-index: -1;
    content: ""; /* 伪元素需要内容，即使它是空的 */
    position: absolute;
    //  top: 0;
    right: 0;
    left: 0;
  }

  .home-bottom::before {
    border-radius: 10px;
    content: ""; /* 伪元素需要内容，即使它是空的 */
    position: absolute;
    // top: 0;
    right: 0;
    left: 0;
    background: url(../../../public/images/homeBc.png) no-repeat center center,
      linear-gradient(180.06deg, rgb(46, 45, 45) 0.05%, rgb(30, 29, 29) 206.55%);
    background-size: cover;
    opacity: 1; /* 设置透明度 */
    z-index: -1; /* 确保伪元素在内容之下 */
    height: 330px;
  }
}

.el-carousel__indicators--horizontal {
  display: none;
}

/* 设备宽度小于768px时的样式 */
@media screen and (max-width: 768px) {
  body {
    min-width: 100%;
    font-size: 16px; /* 基准字体大小 */
  }
  .home-top {
    height: 246px !important;
    .head {
      padding: 10px 20px !important;
      padding-right: 10px !important;
      background: #032751 !important;
      .companyName {
        img {
          width: 130px !important;
        }
      }
    }
    .phone {
      width: auto !important;
      font-size: 0.8rem !important;
      img {
        width: 16px !important;
        height: 16px !important;
        margin-right: 6px !important;
      }
      .menuCopy {
        display: block !important;
      }
    }
    //   #header_font{
    //     width: 60%!important;
    //     height: 100px!important;
    //     top: 120px!important;
    //     p{
    //       width: 200px!important;
    //       height: 30px!important;
    //       font-size: 14px!important;
    //       margin: 0 auto!important;
    //     }
    //   }
    .menu {
      display: none !important;
    }
  }
  .home-top::before {
    height: 246px !important;
  }
  main {
    .top {
      padding-top: 10px !important;
      padding-bottom: 10px !important;
      // margin-bottom: 12px!important;
      .title {
        .imgBox {
          width: 30px !important;
          height: 30px !important;
          margin-right: 4px;
          img {
            width: 30px !important;
            height: 30px !important;
          }
        }
        .chName {
          font-size: 16px !important;
        }
        .enName {
          font-size: 10px !important;
          margin-top: 2px !important;
        }
      }
      .msg {
        font-size: 10px !important;
        margin-top: 6px !important;
      }
    }
    .swiperBox {
      width: 90% !important;
      height: 420px !important;
      .el-carousel__container {
        height: 420px !important;
      }
      .itemBox {
        display: block !important;
        padding-left: 0px !important;
        padding-right: 0px !important;
        margin-bottom: 20px !important;
        .right {
          .title {
            white-space: normal !important;
            margin-bottom: 8px !important;
            margin-top: 8px !important;
            font-size: 15px !important;
          }
          .msg {
            margin-bottom: 20px !important;
          }
          .time {
            display: none;
          }
        }
        .left {
          width: auto !important;
          margin-right: 0px !important;
          height: 260px !important;
          img {
            width: 100% !important;
            height: 260px !important;
          }
        }
      }
    }
    .newsList {
      width: 90% !important;
      .newsOne {
        justify-content: left !important;
        padding-bottom: 14px !important;
        padding-top: 14px !important;
        border-bottom: 1px solid #ccc !important;
        .left {
          width: 70px !important;
          padding-right: 10px !important;
          .big {
            font-size: 22px !important;
          }
          .small {
            font-size: 16px !important;
          }
        }
        .right {
          width: calc(100% - 70px) !important;
          margin-left: 20px !important;
          overflow: hidden;
          .tit {
            margin-bottom: 10px !important;
            font-size: 15px !important;
          }
          .message {
            width: 100% !important;
            text-overflow: ellipsis !important;
            -webkit-line-clamp: 2 !important;
            overflow: hidden !important;
            display: -webkit-box !important;
            -webkit-box-orient: vertical;
          }
        }
      }
    }
  }
  .home-bottom {
    position: relative;
    .box {
      width: 90% !important;
      .linkBox {
        display: none;
      }
    }
  }
  .home-bottom::after {
    box-shadow: 0 0 0px 66px rgba(0, 0, 0, 0.8) !important;
    width: 100vw !important;
    bottom: 66px;
  }
}
</style>
